import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { firstValueFrom } from "rxjs";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatButtonToggleModule } from "@angular/material/button-toggle";

import { CaptchaDialogComponent } from "../../components/captcha-dialog/captcha-dialog.component";
import { QuizMatchDialogComponent } from "../../components/quiz-match-dialog/quiz-match-dialog.component";

export type QuizQuestion =
  | {
      id: string;
      kind: "radio";
      prompt: string;
      options: { value: string; label: string }[];
    }
  | {
      id: string;
      kind: "slider";
      prompt: string;
      min: number;
      max: number;
      step: number;
      showTicks?: boolean;
      hintLow: string;
      hintHigh: string;
    }
  | {
      id: string;
      kind: "text";
      prompt: string;
      placeholder: string;
      rows: number;
    }
  | {
      id: string;
      kind: "select";
      prompt: string;
      options: { value: string; label: string }[];
    }
  | {
      id: string;
      kind: "toggleGroup";
      prompt: string;
      options: { value: string; label: string }[];
    }
  | {
      id: string;
      kind: "multi";
      prompt: string;
      options: { value: string; label: string }[];
    }
  | {
      id: string;
      kind: "toggle";
      prompt: string;
    }

@Component({
  selector: "app-compatibility-quiz-page",
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatDialogModule
  ],
  templateUrl: "./compatibility-quiz-page.component.html",
  styleUrl: "./compatibility-quiz-page.component.scss"
})
export class CompatibilityQuizPageComponent {
  readonly questions: QuizQuestion[] = [
    {
      id: "q1",
      kind: "radio",
      prompt: "Gage spent all evening cooking you dinner, and it tastes objectively awfull. What do you do?",
      options: [
        { value: "ghost", label: "Leave the room and go home. Delete his number and block him on all social media." },
        { value: "tension", label: "Eat it anyway. You're a good sport." },
        { value: "origin", label: "Politely ask him to make you something else." },
        { value: "busy", label: "Just kinda mush it around on your plate, and secretly order a pizza" }
      ]
    },
    {
      id: "q2",
      kind: "slider",
      prompt: "How would you rate Gage's fashion style?",
      min: 0,
      max: 10,
      step: 1,
      showTicks: true,
      hintLow: "Cutie Pattootie except you're wrong",
      hintHigh: "Cutie Patootie"
    },
    {
      id: "q3",
      kind: "text",
      prompt: "Describe your red flag as if it were a LinkedIn skill.",
      placeholder: "e.g. Advanced multi-tasking: overthinking while smiling…",
      rows: 3
    },
    {
      id: "q4",
      kind: "select",
      prompt: "A group of people are catcalling you in public. What do you expect Gage to do?",
      options: [
        { value: "coffee", label: "Gage should fight them to defend my honor." },
        { value: "episode", label: "Gage should gently confront them. Explain catcalling is inappropriate and  explain the impact it could have." },
        { value: "wifi", label: "We should ignore them and walk away." },
        { value: "sunrise", label: "Gage should throw his fake money clip as a distraction and we make our getaway in the opposite direction." }
      ]
    },
    {
      id: "q5",
      kind: "toggleGroup",
      prompt: "Gage has a huge zit right in the middle of his back, what do you do?",
      options: [
        { value: "never", label: "Ask him if you can pop it (consent is sexy)." },
        { value: "maybe", label: "Pop is when he has let his guard down" },
        { value: "panic", label: "Let him deal with it because he is a grown man who can manage on his own" },
      ]
    },
    {
      id: "q6",
      kind: "text",
      prompt: "You notice lots of bugs and spelling mistakes on Gage's concernng dating website. What do you do",
      placeholder: "Gently let him know it should be corrected.",
      rows: 3
    },
    {
      id: "q7",
      kind: "multi",
      prompt: "You just sent a text, that wasn't funny but don't want it to come across as too serious. How do you end it?",
      options: [
        { value: "haha", label: "haha" },
        { value: "lol", label: "lol" },
        { value: "sorry", label: "Smiley Emoji" },
        { value: "notlike", label: "Nothing. It's fine as it is." },
        { value: "dots", label: "Other" },
      ]
    },
    {
      id: "q8",
      kind: "text",
      prompt: "Gage is stuck in the dryer again. What do you do?",
      placeholder: "Set up the tripod",
      rows: 2
    },
    {
      id: "q9",
      kind: "radio",
      prompt: "A runaway trolley is heading down the tracks toward five workers who will all be killed if the trolley proceeds on its present course. You are standing next to a large switch that can divert the trolley onto a different track. The only way to save the lives of the five workers is to divert the trolley onto another track that only has one worker on it. If you divert the trolley onto the other track, this one worker will die, but the other five workers will be saved. What do you do?",
      options: [
        { value: "battery", label: "Do nothing and let the 5 workers die." },
        { value: "me", label: "Divert the trolley onto the other track, killing the 1 worker. " },
        
      ]
    }
  ];

  /** Bound answers: strings, numbers, string[], or booleans depending on question kind. */
  answers: Record<string, string | number | boolean | string[] | null> = {};

  constructor(private readonly dialog: MatDialog) {
    for (const q of this.questions) {
      if (q.kind === "slider") {
        this.answers[q.id] = Math.round((q.min + q.max) / 2);
      } else if (q.kind === "multi") {
        this.answers[q.id] = [];
      } else if (q.kind === "toggle") {
        this.answers[q.id] = false;
      } else {
        this.answers[q.id] = null;
      }
    }
  }

  isMultiSelected(qid: string, value: string): boolean {
    const list = this.answers[qid];
    return Array.isArray(list) && list.includes(value);
  }

  onAnswer(id: string, value: string | number | boolean | string[] | null): void {
    this.answers[id] = value;
  }

  asNumber(v: unknown): number {
    return typeof v === "number" && !Number.isNaN(v) ? v : 0;
  }

  asString(v: unknown): string {
    if (v === null || v === undefined) return "";
    return typeof v === "string" ? v : String(v);
  }

  asBool(v: unknown): boolean {
    return v === true;
  }

  toggleMulti(qid: string, value: string, checked: boolean): void {
    let list = this.answers[qid];
    if (!Array.isArray(list)) {
      list = [];
      this.answers[qid] = list;
    }
    if (checked) {
      if (!list.includes(value)) list.push(value);
    } else {
      this.answers[qid] = list.filter((v) => v !== value);
    }
  }

  async submit(): Promise<void> {
    const ref = this.dialog.open(CaptchaDialogComponent, {
      width: "400px",
      maxWidth: "96vw",
      panelClass: "captcha-dialog-shell",
      restoreFocus: false,
      autoFocus: "first-tabbable"
    });
    const passed = await firstValueFrom(ref.afterClosed());
    if (passed !== true) return;

    this.dialog.open(QuizMatchDialogComponent, {
      width: "420px",
      maxWidth: "92vw",
      panelClass: "quiz-match-dialog-shell",
      restoreFocus: false,
      autoFocus: "first-tabbable"
    });
  }
}
